"use client";

import { TourModal, TourTriggerButton } from "@repo/dashboard-core";
import { useTranslations } from "next-intl";
import { useState } from "react";

import { tourSteps } from "@/config/tour";

export function TourLauncher() {
  const t = useTranslations("tour");
  const [opened, setOpened] = useState(false);

  return (
    <>
      <TourTriggerButton
        onClick={() => setOpened(true)}
        label={t("trigger.label")}
      />
      <TourModal
        opened={opened}
        onClose={() => setOpened(false)}
        steps={tourSteps}
      />
    </>
  );
}
